var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "template4wrapper" }, [
    _c(
      "div",
      { staticClass: "answersWrapper" },
      _vm._l(this.answers, function (answer, index) {
        return _c(
          "div",
          {
            key: answer.id,
            staticClass: "answerItem",
            class: [
              answer.selected ? "selected" : "",
              answer.disabled ? "disabled" : "",
              answer.textColor === "black"
                ? "ti-text-color-black"
                : "ti-text-color-white",
              answer.backgroundColorText
                ? `ti-bg-color-${answer.backgroundColorText}`
                : (index + 1) % 3 === 0
                ? "ti-bg-color-black"
                : (index + 1) % 2 === 0
                ? "ti-bg-color-red"
                : "ti-bg-color-white ti-text-color-black",
            ],
            style: _vm.answerStyle,
            attrs: {
              title: answer.text,
              "data-cbt": _vm.getDataCbtValue(answer),
            },
            on: {
              click: function ($event) {
                return _vm.selectAnswer(answer.id)
              },
            },
          },
          [
            _c("div", { staticClass: "answerContent" }, [
              _c("div", { staticClass: "ti-fs-28 ti-fs-md-56" }, [
                _vm._v(_vm._s(answer.title)),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "answer-button ti-btn mt-16 w-auto px-20 px-lg-50 position-relative",
                  class: [
                    answer.textColor === "black"
                      ? "ti-btn-third bg-transparent"
                      : (index + 1) % 3 !== 0 && (index + 1) % 2 !== 0
                      ? "ti-btn-third"
                      : "ti-btn-ghost",
                  ],
                  attrs: {
                    "data-cbt": _vm.getDataCbtValue(answer),
                    "aria-label": answer.selected
                      ? _vm.selectedButtonText
                      : _vm.buttonText + " " + answer.title,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.selectAnswer(answer.id)
                    },
                  },
                },
                [
                  answer.selected
                    ? _c("img", {
                        staticClass: "answerSelectedIcon mr-8",
                        class:
                          (index + 1) % 3 !== 0 && (index + 1) % 2 !== 0
                            ? "answerSelectedIcon--inverted"
                            : "",
                        attrs: {
                          src: _vm.images.checkmark,
                          alt: _vm.selectedButtonText,
                          "data-cbt": _vm.getDataCbtValue(answer),
                        },
                      })
                    : _vm._e(),
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        answer.selected
                          ? _vm.selectedButtonText
                          : _vm.buttonText
                      ) +
                      "\n                "
                  ),
                ]
              ),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }